

$( document ).ready(function() {
    $( ".search-button-desktop" ).click(function() {
      $("#something-to-say").addClass("np-display-none");
      $("#search").removeClass("np-display-none");
    });
  
  	$( "#new-search-close-button" ).click(function() {
      $("#search").addClass("np-display-none");
      $("#something-to-say").removeClass("np-display-none");
    });
});

